import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {AUDIENCES_QUERY_KEY, TEMPLATES_QUERY_KEY} from "../queryKeys";

type DeleteTemplateVariables = {id: string; deleteTranslations?: boolean};

const deleteTemplate = async ({id, deleteTranslations = true}: DeleteTemplateVariables): Promise<boolean> => {
  const response = await axiosReachInstance.delete<boolean, AxiosResponse<boolean>>(`/templates/${id}`, {
    params: {delete_translations: deleteTranslations},
  });
  return response.data;
};

export const useDeleteTemplate = (
  options?: BaseMutationOptions<boolean, DeleteTemplateVariables>
): BaseUseMutationResult<boolean, DeleteTemplateVariables> => {
  return useBaseMutation<boolean, DeleteTemplateVariables>(deleteTemplate, {
    ...options,
    prefixKeysToReset: () => [[TEMPLATES_QUERY_KEY], [AUDIENCES_QUERY_KEY]],
  });
};
